import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import FloatingInput from "../common/FloatingInput";
import {
  residenceClientAssginment,
  SOARResources,
  censusServiceConfigs,
} from "../services/soar";
import { addDailyService } from "../rev/RevService";

function BedClientHistory({ bed, data, setData, updateData }) {
  const [clientAssignmentOpen, setClientAssignmentOpen] = useState(false);
  const [addServiceDayOpen, setAddServiceDayOpen] = useState(false);
  const [selectedClientAssignment, setSelectedClientAssignment] = useState({});
  const [selectedServiceData, setSelectedServiceData] = useState({});
  const navigate = useNavigate();
  const applicationId =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "5dae139e-d052-4bd8-bf4a-499a31ac3c15"
      : "58990f83-8566-4ba8-b4b5-584a64e4cba1";

  const dischargeClientAssignment = async () => {
    if (selectedClientAssignment.dischargeDate) {
      const dischargeClientAssignmentResponse = await residenceClientAssginment(
        {
          command: "discharge",
          id: selectedClientAssignment.id,
          application: applicationId,
          discharge: selectedClientAssignment.dischargeDate,
          dischargeReason: selectedClientAssignment.dischargeReason,
        }
      );

      if (dischargeClientAssignmentResponse.code === "success") {
        toast.success("Discharge successful!");
        setClientAssignmentOpen(false);
        setSelectedClientAssignment({});
        updateData();
      } else {
        toast.error(`Error: ${dischargeClientAssignmentResponse.message}`);
      }
    } else {
      toast.error("Discharge date is required.");
    }
  };

  const handleReAssignClient = async (id, bedId) => {
    const response = await residenceClientAssginment({
      command: "retract",
      id: id,
      application: applicationId,
      bed: bedId,
    });

    if (response.code === "success") {
      toast.success("Client reassigned successfully!");
      updateData();
    } else {
      toast.error(`Error: ${response.message}`);
    }
  };

  const handleAddDailyService = async () => {
    // console.log("INFO", {
    //   clientAdmission: selectedServiceData.clientAdmission,
    //   bed: selectedServiceData.bed,
    //   serviceDate: selectedServiceData.date,
    // });
    const clientResponse = await SOARResources({
      command: "query",
      environment:
        process.env.REACT_APP_ENVIRONMENT === "Production"
          ? "SOARQueryLive"
          : "SOARQueryBase",
      resource: "client",
      keyword: "byid",
      ids: [selectedServiceData.clientAdmission.client],
    });
    if (clientResponse.code === "success") {
      const cp = clientResponse.data?.[0]?.programs.find(
        (p) => p.id === selectedServiceData.clientAdmission.clientProgram
      );
      const response = await addDailyService(
        {
          client: {
            id: selectedServiceData.clientAdmission.client,
            name: selectedServiceData.clientAdmission.clientName,
            dob: clientResponse.data?.[0]?.dob,
          },
          id: cp.id,
          name: cp.name,
          unit: cp.unit,
        },
        {
          ...selectedServiceData.clientAdmission,
          bed: selectedServiceData.bed,
        },
        data.binti[0] ? data.binti[0]?.["application-home-name"] : data.name,
        selectedServiceData.date,
        selectedServiceData.serviceStatus
      );
      if (response.code === "success") {
        toast.success("Daily service added successfully!");
      } else {
        toast.error(`Error adding daily service: ${response.message}`);
      }
    } else {
      toast.error(`Error getting client info: ${clientResponse.message}`);
    }
  };
  return (
    <>
      <Modal
        show={clientAssignmentOpen}
        onHide={() => setClientAssignmentOpen(false)}
        animation={false}
      >
        <Modal.Header closeButton className="bg-safy-info text-white">
          <Modal.Title>Client Bed Discharge</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div></div>
          <FloatingInput
            type="date"
            name="dischargeDate"
            label="Discharge Date"
            value={selectedClientAssignment.dischargeDate}
            onChange={(e) =>
              setSelectedClientAssignment({
                ...selectedClientAssignment,
                dischargeDate: e.target.value,
              })
            }
          />
          <FloatingInput
            type="select"
            name="dischargeReason"
            label="Discharge Reason"
            options={[
              {
                _id: "Adoption Outside of SAFY",
                name: "Adoption Outside of SAFY",
              },
              {
                _id: "Transferring to Another Foster Home",
                name: "Transferring to Another Foster Home",
              },
              {
                _id: "Transferring to Another Bed in the Same Home",
                name: "Transferring to Another Bed in the Same Home",
              },
              {
                _id: "Transferring to Another SAFY Program",
                name: "Transferring to Another SAFY Program",
              },

              {
                _id: "Discharged from Program/SAFY",
                name: "Discharged from Program/SAFY",
              },
              {
                _id: "Foster Parent Gave Notice",
                name: "Foster Parent Gave Notice",
              },
              { _id: "Respite Only", name: "Respite Only" },
            ]}
            value={selectedClientAssignment.dischargeReason}
            onChange={(e) =>
              setSelectedClientAssignment({
                ...selectedClientAssignment,
                dischargeReason: e.target.value,
              })
            }
          />
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-primary"
            onClick={() => {
              dischargeClientAssignment();
            }}
            disabled={
              !selectedClientAssignment.dischargeDate ||
              selectedClientAssignment.dischargeDate === "" ||
              !selectedClientAssignment.dischargeReason ||
              selectedClientAssignment.dischargeReason === ""
            }
          >
            Save
          </button>
          <button
            className="btn btn-danger"
            onClick={() => {
              setClientAssignmentOpen(false);
              setSelectedClientAssignment({});
            }}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={addServiceDayOpen}
        onHide={() => {
          setSelectedServiceData({});
          setAddServiceDayOpen(false);
        }}
        animation={false}
      >
        <Modal.Header closeButton className="bg-safy-info text-white">
          <Modal.Title>Add Service Day for Client</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div></div>
          <FloatingInput
            type="date"
            name="serviceDate"
            label="Date to Add"
            value={selectedServiceData.date}
            onChange={(e) =>
              setSelectedServiceData({
                ...selectedServiceData,
                date: e.target.value,
              })
            }
          />
          <FloatingInput
            type="select"
            name="serviceStatus"
            label="Service Status"
            options={
              selectedServiceData.serviceConfig?.configuration?.serviceStatuses.map(
                (status) => ({
                  _id: status,
                  name: status,
                })
              ) || []
            }
            value={selectedServiceData.serviceStatus}
            onChange={(e) =>
              setSelectedServiceData({
                ...selectedServiceData,
                serviceStatus: e.target.value,
              })
            }
          />
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-primary"
            onClick={() => {
              handleAddDailyService();
            }}
            disabled={
              !selectedServiceData.date ||
              selectedServiceData.date === "" ||
              !selectedServiceData.serviceStatus ||
              selectedServiceData.serviceStatus === ""
            }
          >
            Save
          </button>
          <button
            className="btn btn-danger"
            onClick={() => {
              setAddServiceDayOpen(false);
              setSelectedServiceData({});
            }}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
      <div className="bg-white p-2 border border-dark text-dark rounded my-2">
        <div className="row text-dark m-0">
          <div className="col">Client</div>
          <div className="col">Service Config</div>
          <div className="col">Admit</div>
          <div className="col">Discharge</div>
          <div className="col"></div>
        </div>
        {bed.clientHistory
          ?.slice()
          .sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn))
          .map((client, index) => (
            <div
              key={client.id}
              className="row border-top border-dark pt-1 m-0"
            >
              <div className="col fw-bold">
                <div
                  className={
                    client.discharge
                      ? "btn btn-sm btn-secondary"
                      : "btn btn-sm btn-primary"
                  }
                  role="button"
                  onClick={() => navigate(`/client/${client.client}`)}
                >
                  {client.clientName}
                </div>
              </div>
              <div className="col">{client.serviceConfigurationName}</div>
              <div className="col">
                {client.admission}
                <i className="fas fa-pen fa-xs text-danger ms-1" />
              </div>
              <div className="col">
                {client.discharge && (
                  <div title={client.dischargeReason}>
                    {client.discharge}
                    <i
                      className="fas fa-circle-xmark fa-xs text-danger ms-1"
                      onClick={() => handleReAssignClient(client.id, bed.id)}
                    />
                  </div>
                )}
              </div>
              <div className="col">
                <i
                  className="rounded border border-dark fas fa-eye bg-white text-primary p-2 mx-1 float-end"
                  title="View Daily Services"
                  role="button"
                  onClick={() =>
                    navigate(
                      `/client/services/${client.client}/${bed.residence}/${client.id}`
                    )
                  }
                ></i>
                {/* <i
                  className="rounded border border-dark fas fa-user-plus bg-white text-success p-2 mx-1 float-end"
                  title="Re-Assign Client"
                  role="button"
                  onClick={() => {
                    handleReAssignClient(client.id, bed.id);
                  }}
                ></i> */}
                {(!client.discharge || client.discharge === "") && (
                  <>
                    <i
                      className="rounded border border-dark fas fa-user-minus bg-white text-danger p-2 mx-1 float-end"
                      title="Discharge Client"
                      role="button"
                      onClick={() => {
                        setSelectedClientAssignment(client);
                        setClientAssignmentOpen(true);
                      }}
                    ></i>
                    <i
                      className="rounded border border-dark fas fa-file-invoice text-primary bg-white p-2 mx-1 float-end"
                      title="Add Daily Service"
                      onClick={async () => {
                        const serviceConfigResponse =
                          await censusServiceConfigs({
                            command: "query",
                            application: applicationId,
                            keyword: "byid",
                            ids: [client.serviceConfiguration],
                          });
                        if (serviceConfigResponse.code === "success") {
                          const serviceConfig = serviceConfigResponse.data?.[0];
                          if (serviceConfig) {
                            setSelectedServiceData({
                              clientAdmission: client,
                              bed: bed,
                              date: "",
                              serviceConfig: serviceConfig,
                            });
                            setAddServiceDayOpen(true);
                          } else {
                            toast.error("Error loading service configuration.");
                          }
                        }
                      }}
                    />
                  </>
                )}
              </div>
            </div>
          ))}
      </div>
    </>
  );
}

export default BedClientHistory;
